import { Typography } from '@pwskills/rachnaui';
import { classNames } from '@pwskills/rachnaui/utils';
import React from 'react';

type Props = {
  classes?: string;
  title: string;
  subtitle?: string;
  isSeo?: boolean;
  id?: string;
};

const Headers = (props: Props) => {
  const { classes, title, subtitle, isSeo, id } = props;

  return (
    <div id={id || ''}>
      <Typography
        component={isSeo ? 'h1' : 'h2'}
        variant="bold"
        className={classNames(
          'text-center regular:!text-left font-inter text-gray-900 !w-full text-[22px] medium:!text-[32px]',
          subtitle ? 'pb-0' : 'pb-0',
          'center-important ',
          classes || ' '
        )}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="light"
          component="body-regular"
          className="text-[#1B2124] text-center regular:!text-left mt-2"
        >
          {subtitle}
        </Typography>
      ) : null}
    </div>
  );
};

export default Headers;
